export default __webpack_public_path__ + "c1c00a80b119f18e796cd0e81335773c.svg";